import { Link } from "react-router-dom";
import * as Icons from "lucide-react";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { Button } from "@/components/ui/button";
import { useAppointment } from "@/context/AppointmentContext";
import { SERVICE_CATEGORIES } from "@/data/services";

export function ServicesOverview() {
  const { openDialog } = useAppointment();

  return (
    <section data-testid="services-overview" className="py-20 sm:py-28 bg-brand-mist">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-5">
          <div>
            <p className="label-eyebrow">Our Services</p>
            <h2 className="mt-3 font-heading text-3xl lg:text-4xl font-medium tracking-tight text-brand-navy max-w-2xl text-balance">
              Comprehensive diagnostics under one roof
            </h2>
          </div>
          <Link to="/services" data-testid="view-all-services">
            <Button variant="ghost" className="rounded-full text-brand hover:bg-brand-soft gap-2">
              View all services <ArrowRight className="h-4 w-4" />
            </Button>
          </Link>
        </Reveal>

        <div className="mt-12 grid gap-6 lg:grid-cols-3">
          {SERVICE_CATEGORIES.map((cat, i) => {
            const Icon = Icons[cat.icon] || Icons.Activity;
            return (
              <Reveal key={cat.id} delay={i * 0.1}>
                <div
                  data-testid={`service-category-${cat.id}`}
                  className="group h-full overflow-hidden rounded-2xl bg-white border border-border transition-all duration-300 hover:-translate-y-1.5 hover:shadow-2xl hover:shadow-brand/10"
                >
                  <div className="relative h-48 overflow-hidden">
                    <img src={cat.image} alt={cat.title} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
                    <div className="absolute inset-0 bg-gradient-to-t from-brand-navy/70 to-transparent" />
                    <span className="absolute top-4 left-4 grid place-items-center h-12 w-12 rounded-xl bg-white/95 text-brand shadow-lg">
                      <Icon className="h-6 w-6" strokeWidth={1.6} />
                    </span>
                    <h3 className="absolute bottom-4 left-4 font-heading text-xl font-semibold text-white">{cat.title}</h3>
                  </div>
                  <div className="p-6">
                    <p className="text-sm text-muted-foreground leading-relaxed">{cat.blurb}</p>
                    <ul className="mt-4 flex flex-wrap gap-2">
                      {cat.services.slice(0, 4).map((s) => (
                        <li key={s.name} className="text-xs font-medium text-brand-navy/70 bg-brand-soft rounded-full px-3 py-1">
                          {s.name}
                        </li>
                      ))}
                      <li className="text-xs font-semibold text-brand bg-white border border-brand/20 rounded-full px-3 py-1">
                        +{cat.services.length - 4} more
                      </li>
                    </ul>
                    <div className="mt-6 flex items-center gap-3">
                      <Button onClick={() => openDialog()} size="sm" className="rounded-full bg-booking hover:bg-booking-dark">
                        Book Now
                      </Button>
                      <Link to="/services" className="text-sm font-semibold text-brand hover:underline flex items-center gap-1">
                        Details <ArrowRight className="h-3.5 w-3.5" />
                      </Link>
                    </div>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
